import { onBeforeUnmount, onMounted, ref, type Ref } from 'vue';

export interface TableColumn {
  left: number;
  width: number;
}

export function useTableColumns(container: Ref<HTMLElement | null>) {
  const columns = ref<TableColumn[]>([]);
  let resizeObserver: ResizeObserver | null = null;

  function measure() {
    const table = container.value?.querySelector<HTMLElement>('table');
    if (!table) return;

    const base = table.getBoundingClientRect();
    columns.value = Array.from(table.querySelectorAll<HTMLElement>('thead th')).map((th) => {
      const rect = th.getBoundingClientRect();
      return { left: rect.left - base.left, width: rect.width };
    });
  }

  onMounted(() => {
    measure();
    if (container.value) {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(container.value);
    }
  });

  onBeforeUnmount(() => {
    resizeObserver?.disconnect();
  });

  return {
    columns,
    measure,
  };
}
